/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Store_AssetsInputs */

const en_svchip_store_assets = /** @type {(inputs: Svchip_Store_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store assets`)
};

const ar_svchip_store_assets = /** @type {(inputs: Svchip_Store_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أصول المتجر`)
};

const bn_svchip_store_assets = /** @type {(inputs: Svchip_Store_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্টোর অ্যাসেট`)
};

const de_svchip_store_assets = /** @type {(inputs: Svchip_Store_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets speichern`)
};

const es_svchip_store_assets = /** @type {(inputs: Svchip_Store_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activos de la tienda`)
};

const fr_svchip_store_assets = /** @type {(inputs: Svchip_Store_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stocker les actifs`)
};

const pt_svchip_store_assets = /** @type {(inputs: Svchip_Store_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armazenar ativos`)
};

const zh_svchip_store_assets = /** @type {(inputs: Svchip_Store_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`存储资产`)
};

const tr_svchip_store_assets = /** @type {(inputs: Svchip_Store_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mağaza varlıkları`)
};

const ru_svchip_store_assets = /** @type {(inputs: Svchip_Store_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Магазин активов`)
};

const pl_svchip_store_assets = /** @type {(inputs: Svchip_Store_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przechowuj zasoby`)
};

/**
* | output |
* | --- |
* | "Store assets" |
*
* @param {Svchip_Store_AssetsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_store_assets = /** @type {((inputs?: Svchip_Store_AssetsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Store_AssetsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_store_assets(inputs)
	if (locale === "bn") return bn_svchip_store_assets(inputs)
	if (locale === "de") return de_svchip_store_assets(inputs)
	if (locale === "es") return es_svchip_store_assets(inputs)
	if (locale === "fr") return fr_svchip_store_assets(inputs)
	if (locale === "pt") return pt_svchip_store_assets(inputs)
	if (locale === "zh") return zh_svchip_store_assets(inputs)
	if (locale === "tr") return tr_svchip_store_assets(inputs)
	if (locale === "ru") return ru_svchip_store_assets(inputs)
	if (locale === "pl") return pl_svchip_store_assets(inputs)
	return en_svchip_store_assets(inputs)
});